import PageContentContainer from "../../Container/PageContentContainer";
import PageHeadline from "../../PageHeadline/PageHeadline";
import ActiveBeaRetries from "../AdminBoard/BeaRetries/ActiveBeaRetries";
import BeaExpertStatusReport from "./BeaExpertStatusReport";

export default function BeaStatusPage() {
  return (
    <PageContentContainer>
      <PageHeadline main="beA-Status" />
      <ActiveBeaRetries />
      <BeaExpertStatusReport />
    </PageContentContainer>
  );
}
